export default "/images/evm_logo.png?8752fb91203ba6ffa1d22df2db6b7090";